import GetDriverInfoSymbols from '../symbols/getDriverInfo';
import { HttpRequestGet } from "../../service";
const getDriverInfoAction = () => ({
  type: GetDriverInfoSymbols.GET_DRIVER_INFO,
});
const getDriverInfoSuccessAction = (data: any) => ({
  type: GetDriverInfoSymbols.GET_DRIVER_INFO_SUCCESS,
  payload: data,
});
const getDriverInfoFailureAction = (data: any) => ({
  type: GetDriverInfoSymbols.GET_DRIVER_INFO_FAILURE,
  payload: data,
});
const cleargetDriverInfoAction = () => ({
  type: GetDriverInfoSymbols.CLEAR_GET_DRIVER_INFO,
});
export function getDriverInfo(driverId: string, callback?: Function) {
  let url = `/admin/delivery/driver/${driverId}`;
  return (dispatch: any) => {
    dispatch(getDriverInfoAction());
    HttpRequestGet(
      url,
      dispatch,
      getDriverInfoSuccessAction,
      getDriverInfoFailureAction,
      true,
      callback
    );
  };
}

export function clearDriverInfo() {
  return (dispatch: any) => {
    dispatch(cleargetDriverInfoAction());
  };
}
